export const DASHBOARD_SIDEBAR_WIDTH_EXPANDED = 280;
export const DASHBOARD_SIDEBAR_WIDTH_COLLAPSED = 80;
export const DASHBOARD_SIDEBAR_AUTO_COLLAPSE_MAX_WIDTH = 1100;

export function getDashboardSidebarWidth(isCollapsed: boolean) {
  return isCollapsed
    ? DASHBOARD_SIDEBAR_WIDTH_COLLAPSED
    : DASHBOARD_SIDEBAR_WIDTH_EXPANDED;
}

export function getDashboardSidebarCollapseMediaQuery() {
  return `(max-width: ${DASHBOARD_SIDEBAR_AUTO_COLLAPSE_MAX_WIDTH}px)`;
}

export function shouldCollapseDashboardSidebarByWidth(width: number) {
  return width <= DASHBOARD_SIDEBAR_AUTO_COLLAPSE_MAX_WIDTH;
}
